import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import { notification } from 'antd';

const ClipboardContext = createContext();

export const useClipboard = () => useContext(ClipboardContext);

const AUTO_CLEAR_MS = 10000;

export const ClipboardProvider = ({ children }) => {
    const [accumulatedTexts, setAccumulatedTexts] = useState([]);
    const timerRef = useRef(null);

    // Clear the accumulated selection if no new pick happens within 10s.
    const scheduleAutoClear = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setAccumulatedTexts([]);
        }, AUTO_CLEAR_MS);
    };

    // options.reset (Ctrl held): drop the history and keep only this value.
    const addText = (text, options = {}) => {
        const { reset = false } = options;

        setAccumulatedTexts(prev => {
            let texts;
            if (reset) {
                texts = [text];
            } else if (prev.includes(text)) {
                texts = prev; // already there → don't add the same value again
            } else {
                texts = [...prev, text];
            }

            navigator.clipboard.writeText(texts.join('\n'));
            notification.success({
                message: 'Copied to clipboard',
                description: `${texts.length} texts copied`,
                placement: 'topRight',
                duration: 2
            });
            return texts;
        });

        scheduleAutoClear();
    };

    useEffect(() => () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    return (
        <ClipboardContext.Provider value={{ addText }}>
            {children}
        </ClipboardContext.Provider>
    );
};
